
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["sprite sprite--logo sprite--basic book-overview-logo__sprite",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.1","id":"logo","x":"0","y":"0","width":"132.7","height":"25.9","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M45.5 13c.7-.8 1.1-1.9 1.1-3.2 0-3.3-2.8-5.6-6.4-5.6H33.4v18.9h8.9c3.6 0 6.4-2.3 6.4-5.6 0-2.2-1.3-3.8-3.2-4.5zm-7.3-4.6H40c1.2 0 1.9.7 1.9 1.7s-.7 1.7-1.9 1.7h-1.8V8.4zM42 19h-3.8v-3.3H42c1.1 0 1.9.5 1.9 1.7S43.1 19 42 19zM51.1 1.6H56v21.5h-4.9zM59.2 8.8h4.9v14.3h-4.9zM61.6.8c-1.7 0-3 1.3-3 2.9 0 1.6 1.3 2.9 3 2.9s3-1.3 3-2.9c.1-1.6-1.3-2.9-3-2.9zM75.9 8.5c-1.7 0-3.1.6-4 1.5V8.8h-4.5v14.3h4.9V15c0-1.3.9-2.1 2.1-2.1 1.2 0 2.1.8 2.1 2.1v8.1h4.9v-8.8c-.1-3.5-2.2-5.8-5.5-5.8zM99.5 8.8h-5.7l-4.4 5.8v-13h-5v21.5h5v-7.5l5.1 7.5h5.4l-5.3-7.9zM101.5 8.8h4.9v14.3h-4.9zM103.9.8c-1.7 0-3 1.3-3 2.9 0 1.6 1.3 2.9 3 2.9s3-1.3 3-2.9c0-1.6-1.3-2.9-3-2.9zM116.2 14.2l-1.4-.6c-.7-.3-1-.4-1-.8s.4-.5 1-.5c1.1 0 2.1.4 3 1.2l2.3-3c-1.4-1.5-3.3-2.1-5.4-2.1-3.3 0-5.6 1.7-5.6 4.5 0 2.4 1.5 3.5 4.2 4.6l1.6.7c.5.2.8.4.8.7 0 .5-.6.6-1.3.6-1.4 0-2.8-.6-4-1.8l-2.3 2.9c1.3 1.8 3.6 2.7 6.2 2.7 3.4 0 5.9-1.7 5.9-4.8.2-2.2-1.4-3.3-4-4.3zM130.9 19c-1.8 0-2.5-.5-2.5-1.9v-4.2h3.8V8.8h-3.8V5.4h-4.9v3.4h-2.2v4.1h2.2v4.7c0 3.9 2.3 5.8 6.3 5.8 1.1 0 2.1-.1 2.9-.3V19h-1.8z"}}),_c('path',{attrs:{"id":"Path","d":"M19.4 0l-5.9 6-5.9-6C3.1 2.2 0 6.9 0 12.3 0 19.8 6 26 13.5 26 20.9 26 27 19.9 27 12.3 27 6.9 23.9 2.2 19.4 0z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#2cde80"}}),_c('path',{staticClass:"st0",attrs:{"d":"M17.1 9.6L13.6 6 10 9.6c-2 2-2 5.3 0 7.3s5.2 2 7.2 0c1.9-2 1.9-5.3-.1-7.3z"}})])
          )
        }
      }
    